<template>
  <IndexPageSection
    v-if="displayableNewArrival"
    :need-link="false"
    :need-to-move-link-to-bottom="false"
    :section-name="'new-arrival'"
    :title="'最新のギフトから探す'"
  >
    <div class="special-feature__lead">
      <div v-if="isLoading" class="new-arrival__loading">
        <Loading />
      </div>
      <div v-else class="new-arrival__items">
        <div class="new-arrival__horizontal-scroll">
          <HorizontalScroll ref="new-arrival-horizontal" ref-name="new-arrival">
            <ItemBoxes
              :items="newArrivalItems"
              :scrollable="false"
              @mount="onMountItemBoxes"
            />
          </HorizontalScroll>
        </div>
      </div>
    </div>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection'
import ItemBoxes from '../../../molecules/item_boxes/ItemBoxes'
import Loading from '../../../atoms/loadings/Loading'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll'
export default {
  components: { IndexPageSection, ItemBoxes, Loading, HorizontalScroll },
  data() {
    return {
      newArrivalItems: [],
      isLoading: false
    }
  },
  computed: {
    displayableNewArrival() {
      return !this.isLoading && this.newArrivalItems.length !== 0
    }
  },
  mounted() {
    this.getNewArrivalItems()
  },
  methods: {
    async getNewArrivalItems() {
      this.isLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/items/new_arrival')
        this.newArrivalItems = res.data.data
          .map(items => items.attributes)
          .map(item => ({
            id: item.id,
            linkUrl: `/items/${item.id}`,
            imageUrl: item.item_box_image_url,
            brandName: item.brand_name,
            itemName: item.name,
            itemPrice: `¥${item.min_price.toLocaleString()}`,
            isIncludingTax: item.is_including_tax,
            hasMultipleItemSkus: item.item_sku_count > 1,
            isDeliveryItem: item.is_delivery_item
          }))
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
      this.isLoading = false
    },
    onMountItemBoxes() {
      this.$refs['new-arrival-horizontal'].initializeValues()
    }
  }
}
</script>
